export default __webpack_public_path__ + "static/media/bharath.218ad996.webp";